// export const context = "/_api";
export const context = window.publicServiceDomain || "";
export const manage = window.manage || "";
export const deleteBz = window.deleteBz || "";

export const API = {
  // 初始化数据
  serInit: window.publicInitApi,
  // serInit: context + "/ai-helper/init",
  newChat: context + "/ai-helper/znt/newChat",
  sessionList: context + "/ai-helper/znt/chat/session/list",
  deleteChat: context + "/ai-helper/znt/chat/delete",
  updateChat: context + "/ai-helper/znt/chat/update",
  // 智能问答
  serSocket: `${window.publicAIDomain}/qa`,
  // 自动输入
  serAutoComplete: context + "/ai-helper/ai-tips",
  // 同意
  serAgree: context + "/ai-helper/agree",
  categaryList: context + "/ai-helper/znt/list?categoryId=",
  categary: context + "/ai-helper/znt/category",
  // 评价
  serEvaluate: context + "/ai-helper/score",
  zntHistory: context + "/ai-helper/znt/chatHistroy",
  zntSearch: context + "/ai-helper/znt/search",
  // 免责声明（已废弃）
  serDisclaimer: context + "/_web/apps/wdzsk/dataopen/api/znwd.rst",
  // 快捷短语（已废弃）
  serReplies: context + "/_web/apps/wdzsk/dataopen/api/tjzts.rst",
  // 服务导办（已废弃）
  serGuide: context + "/_web/apps/wdzsk/dataopen/api/fwyys.rst",
  sessionHistory: context + "/ai-helper/znt/chat/history",
  // 智能问答（已废弃）
  socket: "ws://8.131.59.22:83/websocket",
  // 自动输入（已废弃）
  autoComplete: "/chat-service/autocomplete",
  //获取对话列表
  getChatList: context + "/ai-helper/history",
  //获取帮助信息
  getHelpInfo: context + "/ai-helper/znt/helpInfo",
  //录音
  audioSocket: `${window.publicAudioApi}`,
  //语音转文字
  audio2text: context + "/ai-helper/tool/audio2text",
  //文件下载
  downDocs: context + "/ai-helper/znt/doc/download",
  //文件上传
  uploadDocs: context + "/ai-helper/znt/doc/upload",
  //问答附件下载
  askDownLoadDocs: context + "/ai-helper/znt/doc/temp/show",
  //获取对话管理数据
  getChatManageData: manage + "/api/chatSessionlogs.rst",
  //处理对话数据
  handleChatStatus: manage + "/api/handleSetting.rst",
  //删除标注
  deleteBz: deleteBz + "/api/markzss.rst",
  //获取任务列表
  getSkillList: context + "/ai-helper/znt/skills?zntId=",
  //获取精选智能体
  getSelectedZnt: context + "/ai-helper/znt/recommend",
  //获取部门数据
  getDepartmentData: context + "/ai-helper/znt/departments",
  //获取模型分类
  getModelType: context + "/ai-helper/model/category",
  //获取模型列表
  getModelList: context + "/ai-helper/model/list",
  //获取模型详情
  getModelDetail: context + "/ai-helper/model/detail",
  //获取token使用量
  getTokenConsumption: context + "/ai-helper/model/token",

  //添加收藏
  addFavorite: context + "/ai-helper/znt/favorite/add",
  //取消收藏
  cancelFavorite: context + "/ai-helper/znt/favorite/remove",

  //模型相关

  //公共接口
  //获取模型下拉数据
  getModelSelectData: context + "/px/_web/apps/agent/model/options",
  //获取令牌下拉数据
  getTokenSelectData: context + "/px/_web/apps/agent/token/options",
  //查询用户信息
  getUserInfo: context + "/px/_web/apps/agent/token/user",

  //模型申请相关
  //获取模型类型
  getModelType: context + "/px/_web/apps/agent/model/categories",
  //获取我申请的模型
  getMyApplyModelList: context + "/px/_web/apps/agent/model/list",
  //模型申请
  applyModel: context + "/px/_web/apps/agent/model/apply",
  //删除模型
  deleteModel: context + "/px/_web/apps/agent/model/delete",
  //取消申请
  cancelApply: context + "/px/_web/apps/agent/model/cancel_apply",
  //获取模型申请列表
  getModelApplyList: context + "/px/_web/apps/agent/model/apply_list",
  //获取模型审核列表
  getModelCheckList: context + "/px/_web/apps/agent/model/audit_list",
  //模型审核
  checkModel: context + "/px/_web/apps/agent/model/audit",
  //获取模型详情
  getModelDetailMxgl: context + "/px/_web/apps/agent/model/detail",
  //获取关联令牌列表
  getGllpList: context + "/px/_web/apps/agent/model/token_list",
  //关联令牌
  gllp: context + "/px/_web/apps/agent/model/token_add",
  //取消关联
  qxgllp: context + "/px/_web/apps/agent/model/token_cancel",

  //令牌相关
  //获取令牌列表
  getTokenList: context + "/px/_web/apps/agent/token/list",
  //创建令牌
  createToken: context + "/px/_web/apps/agent/token/create",
  //更新令牌
  updateToken: context + "/px/_web/apps/agent/token/update",
  //删除令牌
  deleteToken: context + "/px/_web/apps/agent/token/delete",

  //智能体上架相关

  //文件上传
  uploadFile: context + "/px/_web/apps/agent/base/file_upload",
  //获取智能体分类
  getZntTypes: context + "/px/_web/apps/agent/agent_publish/categories",
  //获取部门
  getZntDepartment: context + "/px/_web/apps/agent/base/org_list",
  //智能体上架申请
  zntSjApply: context + "/px/_web/apps/agent/agent_publish/apply",
  //获取智能体上架列表
  getZntsjList: context + "/px/_web/apps/agent/agent_publish/apply_list",
  //获取智能体审核列表
  getZntsjCheckList: context + "/px/_web/apps/agent/agent_publish/audit_list",
  //智能体上架审核
  zntsjCheck: context + "/px/_web/apps/agent/agent_publish/audit",
  //获取智能体上架详情
  getZntSjDetail: context + "/px/_web/apps/agent/agent_publish/detail",
  //智能体申请取消
  cancelZntsjsq: context + "/px/_web/apps/agent/agent_publish/cancel",
  //智能体上架和下架
  zntsjAndxj: context + "/px/_web/apps/agent/agent_publish/pub",

  //模型上架相关
  //获取模型上架列表
  getMxsjList: context + "/px/_web/apps/agent/model_publish/apply_list",
  //模型上架申请
  mxsjApply: context + "/px/_web/apps/agent/model_publish/apply",
  //模型上架审核
  mxsjCheck: context + "/px/_web/apps/agent/model_publish/audit",
  //模型上架取消
  mxsjCancel: context + "/px/_web/apps/agent/model_publish/cancel",
  //模型上架审核列表
  mxsjCheckList: context + "/px/_web/apps/agent/model_publish/audit_list",
  //模型上架申请详情
  mxsjDetail: context + "/px/_web/apps/agent/model_publish/detail",
  //模型下架
  mxxj: context + "/px/_web/apps/agent/model_publish/pub",

  //模型部署相关
  //获取模型部署列表
  getMxbsList: context + "/px/_web/apps/agent/model_deployment/apply_list",
  //模型部署申请
  mxbsApply: context + "/px/_web/apps/agent/model_deployment/apply",
  //模型部署审核
  mxbsCheck: context + "/px/_web/apps/agent/model_deployment/audit",
  //模型部署申请取消
  mxbsCancel: context + "/px/_web/apps/agent/model_deployment/cancel",
  //模型部署审核列表
  mxbsCheckList: context + "/px/_web/apps/agent/model_deployment/audit_list",
  //模型部署申请详情
  mxbsDetail:context + "/px/_web/apps/agent/model_deployment/detail",


  //知识库相关
  //获取知识库列表
  getZskList:context + "/px/_web/apps/agent/doc/cls",
  //根据id加载下一层
  getNextZsklist:context + "/px/_web/apps/agent/doc/dir_list",
  //获取文档库分类
  getZskTypes:context + "/px/_web/apps/agent/doc/categories",
  //获取文档库数据
  getZskListData:context + "/px/_web/apps/agent/doc/lib"


};

export default API;

export function getInitData(parameters = {}) {
  return {
    url: API.serInit,
    method: "get",
    params: parameters,
  };
}
export function getcategaryList(type = "") {
  return {
    url: API.categaryList + (type === "0" ? "" : parseInt(type)),
    method: "get",
  };
}
export function getSessionList(params = { zntId: "", count: "" }) {
  return {
    url: API.sessionList,
    method: "get",
    params,
  };
}
export function getNewChat(params) {
  return {
    url: API.newChat,
    method: "post",
    data: params,
  };
}
export function getDeleteChat(chatId) {
  return {
    url: API.deleteChat + "?chatId=" + chatId,
    method: "get",
  };
}
export function getZntHistory() {
  return {
    url: API.zntHistory,
    method: "get",
  };
}
export function getZntSearch(params = { name: "", department: "" }) {
  return {
    url:
      API.zntSearch + `?name=${params?.name}&department=${params?.department}`,
    method: "get",
  };
}
export function getcategary() {
  return {
    url: API.categary,
    method: "get",
  };
}
export function getUpdateChat(params) {
  return {
    url: API.updateChat,
    method: "get",
    params,
  };
}
export function getAgreeData(parameters = {}) {
  return {
    url: API.serAgree,
    method: "get",
    params: parameters,
  };
}

export function getEvaluateData(parameters = {}) {
  return {
    url: API.serEvaluate,
    method: "post",
    data: parameters,
  };
}

export function getDisclaimersData(parameters = {}) {
  return {
    url: API.serDisclaimer,
    method: "get",
    params: parameters,
  };
}

export function getRepliesData(parameters = {}) {
  return {
    url: API.serReplies,
    method: "post",
    data: parameters,
  };
}

export function getGuideData(parameters = {}) {
  return {
    url: API.serGuide,
    method: "post",
    data: parameters,
  };
}

export function getChatList(parameters = { id: "", date: "", count: 10 }) {
  return {
    url:
      API.getChatList +
      `?znwdId=${parameters?.id}&date=${parameters?.date}&count=${parameters?.count}`,
    method: "get",
  };
}
export function getSessionHistory(chaId) {
  return {
    url: API.sessionHistory + `?chatId=${chaId}`,
    method: "get",
  };
}

export function getHelpInfo(chaId) {
  return {
    url: API.getHelpInfo + `?zntId=${chaId}`,
    method: "get",
  };
}

export function getSkillList(id) {
  return {
    url: API.getSkillList + id,
    method: "get",
  };
}

export function getSelectedZnt() {
  return {
    url: API.getSelectedZnt,
    method: "get",
  };
}

export function getDepartmentData() {
  return {
    url: API.getDepartmentData,
    method: "get",
  };
}

export function getModelType() {
  return {
    url: API.getModelType,
    method: "get",
  };
}

export function getModelList(params = {}) {
  return {
    url: API.getModelList,
    method: "get",
    params,
  };
}
export function getModelDetail(id) {
  return {
    url: API.getModelDetail + `?id=${id}`,
    method: "get",
  };
}
export function getTokenConsumption(id) {
  return {
    url: API.getTokenConsumption,
    method: "get",
  };
}

export function getAudio2Text(zntId, file) {
  const formData = new FormData();
  formData.append("files", file);
  return {
    url: API.audio2text + `?zntId=${zntId}`,
    method: "post",
    data: formData,
  };
}

export function getZskTypes() {
  return {
    url: API.getZskTypes,
    method: "get",
  };
}


export function getZskListData(params={}){
  return {
    url:API.getZskListData,
      method: "get",
    params,
  }
}
